// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__15y2w","file":"styles_file__1TkU1"};